import React from "react";
import { ThemeProvider } from "styled-components";
import { Outlet } from "react-router-dom";

import { theme } from "./system/styles/theme";
import { MainMenu } from "./layout/main-menu/ui/main-menu";

// import * as Styled from "./App.styled";

const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <MainMenu />
      <Outlet />
    </ThemeProvider>
  );
};

export default App;
